import { render, staticRenderFns } from "./DeliveryForSelect.vue?vue&type=template&id=72292a47"
import script from "./DeliveryForSelect.vue?vue&type=script&lang=ts"
export * from "./DeliveryForSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports